import container from "@src/container";

import { SelectTabEvent } from "@models/tracking/xapi-events";

export const createCurriculumResourcesTracking = (
  productId,
  productName = ""
) => {
  const { xApiTrackingService } = container;
  const product_in_focus = productName;

  const trackEvent = async (event, options) => {
    event.options = {
      product_in_focus,
      ...options,
      ...event.options,
    };

    await xApiTrackingService.trackEvent(event);
  };

  const trackSelectTabEvent = async () => {
    const event = new SelectTabEvent(productId?.toString(), product_in_focus);

    event.options = {
      product_in_focus,
      ...event.options,
    };

    await xApiTrackingService.trackEvent(event);
  };

  return {
    trackEvent,
    trackSelectTabEvent,
  };
};
